<script setup lang="ts">
  import type { Currency } from '@gat-ship/types'
  import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    Button
  } from '@gat-ship/vue-components'
  import { ref } from 'vue'
  import { useCurrenciesProvider } from '../providers/CurrenciesProvider.vue'

  const currenciesProvider = useCurrenciesProvider()

  const currency = ref<Currency | undefined>(undefined)
  const isOpen = ref(false)

  export interface ShowRemoveCurrencyDialogParams {
    currency: Currency
  }

  function showModal({
    currency: currencyParam
  }: ShowRemoveCurrencyDialogParams) {
    currency.value = currencyParam
    isOpen.value = true
  }

  async function onConfirmRemove() {
    const code = currency.value?.code
    isOpen.value = false
    if (code) {
      await currenciesProvider.removeCurrency(code)
    }
  }

  defineExpose({
    showModal
  })
</script>

<template>
  <AlertDialog v-model:open="isOpen">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Remove Currency</AlertDialogTitle>
        <AlertDialogDescription class="whitespace-pre-line">
          Are you sure you want to remove the currency {{ currency?.code }}?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="outline" @click="onConfirmRemove()"> Confirm </Button>
        <Button variant="ghost" @click="isOpen = false"> Cancel </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
